export default __webpack_public_path__ + "static/media/start-banner-v5-desktop.b0c386d8.svg";